import { Box, Grid, Link, Tab, Typography, styled } from '@mui/material'
import LoginLeft from 'assets/images/login-left.png'
import OtherPaymentOptions from 'assets/images/other-payment-options.png'
import { AuthLayout } from 'components'
import { LOGIN_ITEMS, ROUTES_PATH, WELCOME_DESCRIPTION, WELCOME_TITLE } from 'config'
import { color } from 'config/color'
import { Tabs, tabSx } from 'containers/Billing'
import { useAuth } from 'context'
import type React from 'react'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useMobileBreakpoints } from 'utils/hooks/useMobileBreakpoints'
import { Item, LoginForm, PayForm } from './component'


export const SignIn: React.FC = () => {
  const { handleLogOut } = useAuth()
  const navigate = useNavigate()
  const [activeTab, setActiveTab] = useState<number>(0)
  const isMobile = useMobileBreakpoints()
  const handleTabChange = (_e: any, newActiveTab: number): void => {
    setActiveTab(newActiveTab)
  }
  useEffect(() => {
    void handleLogOut()
    navigate(ROUTES_PATH.SIGNIN)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])


  return (
    <AuthLayout
      title={WELCOME_TITLE}
      desc={WELCOME_DESCRIPTION}
      isAuthPage={true}
    >
      <AuthWrapper isAuthPage={true}>
        <Grid container>
          <Grid item sm={0} md={6}>
            <Box
              sx={{
                backgroundSize: 'cover',
                backgroundImage: `url("${LoginLeft}")`,
                height: '100%'
              }}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Tabs variant='fullWidth' value={activeTab} onChange={handleTabChange} TabIndicatorProps={{ sx: { background: color.primary[500], height: 5 } }}>
              <Tab key={0} label="Pay your Bill" sx={tabSx} />
              <Tab key={1} label="Login or Register" sx={tabSx} />
            </Tabs>
            <AuthMain>
              {activeTab === 0 && <PayForm handleTabChange={handleTabChange} />}
              {activeTab === 1 && <LoginForm />}
            </AuthMain>
          </Grid>
        </Grid>
      </AuthWrapper>
      <Box my={3}>
        {isMobile && <Typography color={color.grey[300]} align="center" fontSize={24} mb={3}>How can we help you?</Typography>}
        <Box display="flex" width="100%" gap={5} flexDirection={isMobile ? 'column' : 'row'} alignItems="center" justifyContent="space-between">
          {LOGIN_ITEMS.map((item) => {
            return (
              <Item
                key={item.title}
                Icon={item.icon}
                title={item.title}
                route={item.link}
              />
            )
          })}
        </Box>
      </Box>
      {isMobile
        ? <Box display="flex" flexDirection="column">
          <Box component="img" src={OtherPaymentOptions} />
          <Box bgcolor={color.background[950]} px={3} py={4}>
            <OtherPaymentOptionsContent />
          </Box>
        </Box>
        : <Box display="flex" gap={2} bgcolor={color.background[950]} px={3} py={4} mt={5} borderRadius={1}>
          <Box component="img" src={OtherPaymentOptions} width={120} height={120} borderRadius={1} />
          <Box>
            <OtherPaymentOptionsContent />
          </Box>
        </Box>}
    </AuthLayout>
  )
}


export const OtherPaymentOptionsContent: React.FC = () => {
  return <>
    <Typography color={color.white} fontSize={24} fontWeight={500}>Other Payment Options</Typography>
    <Typography color={color.white} fontSize={16}>Mail check or money order to Nationwide Energy Partners, PO BOX 183009, Columbus, OH, 43218-3009</Typography>
    <Typography color={color.white} fontSize={16} mt={4}>Need a Payment Plan? <Link href="tel:877-818-2637" color={color.primary[500]} fontSize={16} sx={{ cursor: 'pointer' }} >Call us</Link>.</Typography>
  </>
}
export const AuthWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isAuthPage'
})<{ isAuthPage?: boolean }>(({ isAuthPage }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  margin: (isAuthPage ?? false) ? '40px 0' : '0',
  justifyContent: 'center'
}))

export const AuthMain = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isRounded'
})<{ isRounded?: boolean }>(({ isRounded }) => ({
  backgroundColor: color.white,
  padding: '40px',
  borderRadius: (isRounded ?? false) ? '4px' : '0',
  h4: {
    fontFamily: 'Roboto',
    fontWeight: 400,
    fontSize: '32px',
    lineHeight: '38px',
    textAlign: 'center',
    color: color.black,
    marginBottom: '32px',
    marginTop: 0
  }
}))
